import Blank from './Blank';
import Default from './Default';
import Auth from './Auth';
import Journey from './Journey';

export default { Blank, Default, Auth, Journey };



// WEBPACK FOOTER //
// ./src/layouts/index.js